// import * as types from '../mutation-types'
const actions = {
	createFeedback ({ commit }, feedbackForm) {
		return window.axios.post('/feedback', {
			name: feedbackForm.name,
			email: feedbackForm.email,
			phone: feedbackForm.phone,
			type: feedbackForm.messageType,
			body: feedbackForm.message
		})
	}
}

export default {
	namespaced: true,
	actions
}